import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const About = () => {
    return (
        <Container className="py-5" id="about">
            {/* Section Title */}
            <div className="text-center mb-5">
                <h2 className="fw-bold">About</h2>
                <div
                    style={{
                        width: "60px",
                        height: "3px",
                        backgroundColor: "#F89A33",
                        margin: "10px auto",
                    }}
                ></div>
                <p className="text-muted ">
                    Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit
                </p>
            </div>

            <Row className="align-items-center">
                {/* Left Column */}
                <Col lg={6} className="mb-4 mb-lg-0 ">
                    <Card className="border-0 shadow-sm px-4 rounded-4 py-2 " style={{ backgroundColor: '#fff' }}>
                        <Badge bg="" className="bg-light about-text px-3 py-1 mb-3 rounded-pill" style={{ width: 'fit-content' }}>
                            Our Story
                        </Badge>

                        <h3 className="fw-bold">Designing Meaningful Products With Lasting Impact</h3>
                        <p className="text-muted mt-3 mb-2">
                            Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium totam rem.
                        </p>
                        <p className="text-muted">
                            Quo rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo nemo enim ipsam.
                        </p>

                        {/* Two Feature Cards */}
                        <Row className="my-4">
                            <Col md={6} className="mb-3 mb-md-0">
                                <Card className="h-100 border-light bg-light rounded-4">
                                    <Card.Body>
                                        <div className="mb-2">
                                            <span className="fs-4 about-text">
                                                <img src="mortarboard.png" width="50" alt="education" />
                                            </span>
                                        </div>
                                        <h6 className="fw-bold mb-1">Reliable Delivery</h6>
                                        <p className="small text-muted mb-0">
                                            At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis.
                                        </p>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col md={6}>
                                <Card className="h-100 border-light bg-light rounded-4">
                                    <Card.Body>
                                        <div className="mb-2">
                                            <span className="fs-4 about-text">
                                                <img src="open-book.png" width="50" alt="education" />
                                            </span>
                                        </div>
                                        <h6 className="fw-bold mb-1">Human-Centered Design</h6>
                                        <p className="small text-muted mb-0">
                                            Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus.
                                        </p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        {/* Stats */}
                        <Row className="text-center mb-4 border border-1  rounded-5 p-2 shadow-sm">
                            <Col>
                                <h4 className="about-text fw-bold mb-0">
                                    1500
                                    +</h4>
                                <small className="text-muted">Trainings Conducted</small>
                            </Col>
                            <Col>
                                <h4 className="about-text fw-bold mb-0">
                                    400
                                    +</h4>
                                <small className="text-muted">Companies Tie-Ups</small>
                            </Col>
                            <Col>
                                <h4 className="about-text fw-bold mb-0">
                                    1600
                                    +
                                </h4>
                                <small className="text-muted">Students Placed</small>
                            </Col>
                            <Col>
                                <h4 className="about-text fw-bold mb-0">
                                    150
                                    +</h4>
                                <small className="text-muted">Corporate Training</small>
                            </Col>
                        </Row>

                        {/* Buttons */}
                        <div className="d-flex flex-wrap gap-3">
                            <Button className="px-4 py-2 rounded-3 btn-grad border-0 ">
                                Explore Capabilities
                            </Button>
                            <Button variant="link" className="text-decoration-none text-dark fw-semibold">
                                Learn about our culture &rarr;
                            </Button>
                        </div>
                    </Card>
                </Col>

                {/* Right Column (Image) */}
                {/* Right Column (Full Image) */}
                <Col lg={6} className="d-flex">
                    <div className="w-100  position-relative">
                        <img
                            src="about-img1.jpg"
                            alt="Team collaboration"
                            className="img-fluid w-100 h-100 rounded-4 shadow object-fit-cover "
                            style={{ objectFit: 'cover', minHeight: '110vh' }}
                        />

                        {/* Overlay Card (optional, bottom-left) */}
                        <Card
                            className="position-absolute bottom-0 start-0 m-3 p-2 bg-light border-0 shadow-sm rounded-3"
                            style={{ maxWidth: '220px' }}
                        >
                            <Card.Body className="p-2">
                                <div className="d-flex align-items-center gap-2">
                                    {/* <span className="fs-4 about-text">🌱</span> */}
                                    <div>
                                        <strong>Growing Strong</strong>
                                        <p className="small text-muted mb-0">Lorem ipsum dolor sit amet.</p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default About;
